import { render, staticRenderFns } from "./all-list.vue?vue&type=template&id=3fbb2a3c&scoped=true&"
import script from "./all-list.vue?vue&type=script&lang=js&"
export * from "./all-list.vue?vue&type=script&lang=js&"
import style0 from "./all-list.vue?vue&type=style&index=0&id=3fbb2a3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb2a3c",
  null
  
)

export default component.exports